<template>
	<div class="services">
		<h1>{{title}}</h1>
	</div>
</template>
<script>
export default{
  name: 'blog',
  data () {
    return {
      title: 'services'
    }
  }
}
</script>

<style scoped>

</style>
